// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag-item{color:#fff;font-size:8px;font-weight:700;padding:2px 5px;background-color:#eee;display:inline-flex;justify-content:center;align-items:center;border-radius:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
